import { useSelector } from "react-redux";
import {
  selectSelectedCharacterPart,
  setSelectedCharacterPartDetails,
} from "../../../app/slices/CharacterPartsSlice";
import { useEffect } from "react";
import { CharacterPartService } from "../../../services/CharacterPartService";
import { selectCurrentOrganization } from "../../../app/slices/UserSlice";
import { useDispatch } from "react-redux";

export default function useCharacterPartLibrary() {
  const dispatch = useDispatch();
  const selectedCharacterPart = useSelector(selectSelectedCharacterPart);
  const currentOrganization = useSelector(selectCurrentOrganization);

  useEffect(() => {
    if (!selectedCharacterPart) return;
    loadCharacterPartDetails();
  }, [selectedCharacterPart]);

  const loadCharacterPartDetails = async () => {
    if (!selectedCharacterPart || !currentOrganization) return;

    const characterPartDetails =
      await CharacterPartService.GetCharacterPartGenderedPairDetails(
        currentOrganization.id,
        selectedCharacterPart.name
      );
    if (!characterPartDetails) return;

    if (characterPartDetails) {
      dispatch(setSelectedCharacterPartDetails(characterPartDetails));
    }
  };
}
